<div>
  <app-cms-page></app-cms-page>
  <h1>4DML Portal</h1>
  <h3 #subtitle [class.subtitles-on]="subtitlesOn">New features</h3>
  <div #features class="features" [class.features-on]="featuresOn">
    <h4>Set Points now have a 90 day view.</h4>
    <img src="https://s3.eu-west-2.amazonaws.com/4d-images-cms/setpoints-example-1.png">

  </div>
</div>